"use strict";

exports.__esModule = true;

require('./button.css');

exports.default = {
  "button": "pf-c-button",
  "buttonIcon": "pf-c-button__icon",
  "modifiers": {
    "active": "pf-m-active",
    "block": "pf-m-block",
    "primary": "pf-m-primary",
    "secondary": "pf-m-secondary",
    "tertiary": "pf-m-tertiary",
    "danger": "pf-m-danger",
    "link": "pf-m-link",
    "inline": "pf-m-inline",
    "control": "pf-m-control",
    "expanded": "pf-m-expanded",
    "plain": "pf-m-plain",
    "disabled": "pf-m-disabled",
    "start": "pf-m-start",
    "end": "pf-m-end",
    "overpassFont": "pf-m-overpass-font"
  }
};